import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import contact from '../images/Navbar/contact.png'
import mail from '../images/Navbar/mail.png'
import twitter from '../images/Navbar/twitter.png'
import facebook from '../images/Navbar/facebook.png'
import insta from '../images/Navbar/insta.png'
import search from '../images/Navbar/search.png'
import cart from '../images/Navbar/cart.png'
import profile from '../images/Navbar/profile.png'
import bars from '../images/Navbar/Bars.png'
import logo from '../images/Navbar/logo.png'
import logo1 from '../images/Navbar/logo1.png'
import dashboardpageimg from '../images/Navbar/Dashboard.png'
import { useStore } from '../useStore'
import { decrypt } from '../crypto'
import { useDispatch, useSelector } from 'react-redux';
import LiveViews from '../pages/LiveViews'
import animationData from "../lotties/Live.json";
import Lottie from "lottie-react";
import axios from 'axios'

function Navbar() {

    // const [showDropdown, setShowDropdown] = useState(false);
    const [categories, setCategories] = useState([]);
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;
    const [searchQuery, setSearchQuery] = useState('');

    const admin = useSelector((state) => state.user.admin);

    // const [admin,setAdmin] = useState(null)

    // useEffect(() => {
    //     const isAdmin = localStorage.getItem('i_a');
    //     if (isAdmin) {
    //         setAdmin(decrypt(isAdmin))
    //     }
    // }, [localStorage])

    const { showDropdown, setShowDropdown } = useStore()

    //("pasworddddddd", password);

    const allowedCategoryIds = [
        4,    // T SHIRT
        5,    // JACKET
        6,    // SHORTS
        7,    // TRACK
        219,  // BOTTLE
        301,  // ACCESSORIES
        358,  // CARGO TRACK
        359,  // CARGO SHORTS
        218,  // FULL SLEEVE
        450,  // BOYS TRACK
        448,  // BOYS SHORTS
        616   // POLO T SHIRT
    ];



    useEffect(() => {
        fetch(`${apiBaseUrl}/getCategories/BLACKBATON_2526`)
            .then(response => response.json())
            .then(data => {
                // Filter categories to only include allowed ones
                const filteredCategories = data.filter(category =>
                    allowedCategoryIds.includes(category.Id)
                );
                setCategories(filteredCategories);
            })
            .catch(error => console.error("Error fetching categories:", error));
    }, [apiBaseUrl]);


    // Scroll listener for sticky sub-navbar appearance
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY && currentScrollY > 120) {
                // Scrolling down - hide it
                setIsVisible(false);
                setShowDropdown(false);
            } else {
                // Scrolling up - show it
                setIsVisible(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);


    const navigate = useNavigate();
    const cartpage = () => {
        navigate('/cart')
    }

    const accountpage = () => {
        const loginId = localStorage.getItem('loginId');
        if (loginId) {
            navigate('/account');
        } else {
            navigate('/login');
        }
    }

    const dashboardpage = () => {
        navigate('/dashboard');
    }

    const homePage = () => {
        navigate('/')
        window.location.reload();
    }

    const productPage = (categoryId, categoryName) => {
        navigate('/products', { state: { categoryId, categoryName } });
    };

    const handleSearch = () => {
        if (searchQuery.trim() !== '') {
            navigate('/searchpage', { state: { filtered: searchQuery } });
        }
    };


    const mensubcategorypage = (categoryId) => {
        navigate(`/subcategoryproducts?c=${btoa('627')}&n=${btoa("MEN'S")}`, { state: { categoryId: 627, categoryName: "MEN'S" } });
    };

    const womensubcategorypage = (categoryId) => {
        navigate(`/subcategoryproducts?c=${btoa('628')}&n=${btoa("WOMEN'S")}`, { state: { categoryId: 628, categoryName: "WOMEN'S" } });
    };

    const kidssubcategorypage = (categoryId) => {
        navigate(`/subcategoryproducts?c=${btoa('629')}&n=${btoa("KID'S")}`, { state: { categoryId: 629, categoryName: "KID'S" } });
    };

    const limitedsalesubcategorypage = (categoryId) => {
        navigate(`/subcategoryproducts?c=${btoa('0')}&n=${btoa("LIMITED SALE")}`, { state: { categoryId: 0, categoryName: "LIMITED SALE" } });
    };

    const bestsellersubcategorypage = (categoryId) => {
        navigate(`/subcategoryproducts?c=${btoa('0')}&n=${btoa("BEST SELLER")}`, { state: { categoryId: 0, categoryName: "BEST SELLER" } });
    };

    const newarrival = (categoryId, categoryName) => {
        navigate(`/subcategoryproducts?c=${btoa('0')}&n=${btoa("NEW ARRIVAL")}`, { state: { categoryId: 0, categoryName: 'NEW ARRIVAL' } });
    };

    const [searchProducts, setSearchProducts] = useState([])
    const [searchLoading, setSearchLoading] = useState(false)

    // Cache for image validation results
    const imageValidationCache = React.useRef({});

    // console.log(searchProducts, 'searchProducts');

    // useEffect(() => {
    //     if (searchQuery === '' || searchQuery === null || searchQuery === undefined) {
    //         setSearchProducts([]);
    //     }

    // }, [searchQuery])

    // Helper function to check if an image exists and is accessible
    const checkImageExists = async (imageCode) => {
        if (!imageCode) return false;

        // Check cache first
        if (imageValidationCache.current[imageCode] !== undefined) {
            return imageValidationCache.current[imageCode];
        }

        try {
            // displayFirst already includes .webp extension, so don't add it again
            const imageUrl = imageCode.endsWith('.webp')
                ? `${apiLocalUrl}/uploads/${imageCode}`
                : `${apiLocalUrl}/uploads/${imageCode}.webp`;

            const response = await fetch(imageUrl, {
                method: 'HEAD',
                cache: 'no-cache'
            });
            const result = response.ok;

            // Cache the result
            imageValidationCache.current[imageCode] = result;
            return result;
        } catch (error) {
            imageValidationCache.current[imageCode] = false;
            return false;
        }
    };

    const checkImageExistsFirstColor = async (image) => {
        // Check cache first
        if (imageValidationCache.current[image] !== undefined) {
            return imageValidationCache.current[image];
        }

        try {
            const res = await fetch(`${apiLocalUrl}/check-image/${encodeURIComponent(image)}`);

            if (!res.ok) {
                imageValidationCache.current[image] = false;
                return false;
            }

            const data = await res.json();
            const result = data.exists;

            // Cache the result
            imageValidationCache.current[image] = result;
            return result;
        } catch (err) {
            imageValidationCache.current[image] = false;
            return false;
        }
    };

    const getFirstAvailableColor = async (productId) => {
        try {
            const response = await axios.get(`${apiBaseUrl}/getProductDetails/BLACKBATON_2526?Id=${productId}`);
            if (response.status === 200) {
                const data = response.data;
                const distinctColors = [...new Set(
                    data.filter(item => item.ItemId === productId).map(item => item.Color?.trim()).filter(Boolean)
                )];

                // Check colors in order
                for (const color of distinctColors) {
                    const exists = await checkImageExistsFirstColor(`${productId}_${color}.webp`);
                    if (exists) {
                        return color;
                    }
                }
                return null;
            }
        } catch (error) {
            console.error('Error fetching product details:', error);
            return null;
        }
    };

    const handleSearchValue = async (val) => {

        if (val === '' || val === undefined || val === null) {

            setSearchProducts([]);
            setSearchLoading(false);
            return
        }

        setSearchLoading(true);

        try {

            const response = await fetch(
                `${apiBaseUrl}/getProductByFilter/BLACKBATON_2526?filter=${encodeURIComponent(val)}`
            );

            // Check if the response is OK (status code 200-299)
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }

            // Parse the response as JSON
            const data = await response.json();

            // Handle both array and object responses
            const productsList = Array.isArray(data) ? data : (data.products || []);

            // Proceed if we have products
            if (productsList.length > 0) {
                const validProducts = productsList
                    .filter(item => item?.ItemName && item?.ID)
                    .map(item => {
                        let image = item.displayFirst;
                        if (image && !image.endsWith('.webp')) {
                            image = `${image}.webp`;
                        }
                        return {
                            Id: item.ID,
                            ItemName: item.ItemName.toUpperCase(),
                            displayFirst: image
                        };
                    })
                    .slice(0, 15); // Limit to first 15 results for faster processing

                setSearchProducts(validProducts);
            } else {
                setSearchProducts([]);
            }
            setSearchLoading(false);
        } catch (error) {
            console.error('Error fetching products:', error);
            setSearchProducts([]); // Set products to an empty array if an error occurs
            setSearchLoading(false);
        }
    };

    const handleOnBlur = () => {
        // Small timeout to allow onMouseDown to fire on results
        setTimeout(() => setSearchProducts([]), 200);
    }

    const handleOnFocus = () => {
        if (searchQuery === '' || searchQuery.length < 1) return
        handleSearchValue(searchQuery)
    }

    // Debounce timer ref
    const searchTimeoutRef = React.useRef(null);

    const handleSearchQuery = (e) => {
        const val = e.target.value

        setSearchQuery(val)

        // Clear existing timeout
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        if (val === '' || val.length < 1) {
            setSearchProducts([]);
            return;
        }

        // Set new timeout for debounced search
        searchTimeoutRef.current = setTimeout(() => {
            handleSearchValue(val);
        }, 150); // 150ms debounce delay for faster response
    }

    function encodeBase64(text) {
        return btoa(text);
    }

    const fullimage = (id, itemName) => {
        setSearchProducts([]);
        setSearchQuery('');
        navigate(`/fullimage?I=${encodeBase64(String(id))}&N=${encodeBase64(itemName)}`, { state: { id, itemName } });
    };

    return (
        <div className='flex flex-col' onClick={(e) => {
            e.stopPropagation()
            setShowDropdown(false)
            setSearchProducts([])
        }}>
            <div className='w-full h-[120px] bg-[#000000] border-b-2 border-[#B2B2B2] flex flex-col lg:px-12 px-5 gap-3 fixed top-0 left-0 z-50'>
                <div className='w-full h-[40%]  flex justify-between items-end'>
                    <div className='flex flex-row gap-5 items-center'>
                        <div className='flex flex-row gap-2 items-center'>
                            <img src={contact} alt="contact" />
                            <a href="tel:+919995028039">
                                <span className='text-[#CACACA] font-[400] font-dmSans text-sm hover:text-[red] cursor-pointer'>
                                    +91 9995028039
                                </span>
                            </a>

                        </div>
                        <div className='flex flex-row gap-2 items-center'>
                            <img src={mail} alt="mail" />
                            <a href="mailto:Info.stillsclothing@gmail.com">
                                <span className='text-[#CACACA] font-[400] font-dmSans text-sm hover:text-[red] cursor-pointer'>
                                    Info.stillsclothing@gmail.com
                                </span>
                            </a>
                        </div>
                    </div>

                    <div className="w-max h-max flex flex-row justify-center items-center">
                        {admin === '1' && (
                            <div className="w-6 ">   {/* adjust size here */}
                                <Lottie animationData={animationData} loop={true} />
                            </div>
                        )}

                        <div className="px-2 text-white text-nowrap">
                            <LiveViews pageId={'Blackbaton'} />
                        </div>


                        {admin === '1' && (
                            <div className="w-6 ">   {/* adjust size here */}
                                <Lottie animationData={animationData} loop={true} />
                            </div>
                        )}
                    </div>

                    <div className='flex flex-row gap-3 justify-center items-center'>

                        {/* <div className='w-[25px] h-[25px] rounded-full bg-[#FFFFFF] hover:bg-[red] flex justify-center items-center cursor-pointer'>
                            <img src={twitter} alt="twitter" />
                        </div> */}
                        {/* <div className='w-[25px] h-[25px] rounded-full bg-[#FFFFFF] hover:bg-[red] flex justify-center items-center cursor-pointer'>
                            <img src={facebook} alt="facebook" />
                        </div> */}
                        <a
                            href="https://www.facebook.com/share/1DoGh3dsmd/?mibextid=wwXIfr"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <div className='w-[25px] h-[25px] rounded-full bg-[#FFFFFF] hover:bg-[red] flex justify-center items-center cursor-pointer'>
                                <img src={facebook} alt="facebook" />
                            </div>
                        </a>
                        <a
                            href="https://www.instagram.com/black_baton?igsh=MXE0MG43cDV5ZHdrOQ%3D%3D&utm_source=qr"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <div className='w-[25px] h-[25px] rounded-full bg-[#FFFFFF] hover:bg-[red] flex justify-center items-center cursor-pointer'>
                                <img src={insta} alt="insta" />
                            </div>
                        </a>

                    </div>
                </div>
                <div className='w-full h-[60%]  flex justify-between items-center  '>
                    <img src={logo} alt="logo" className='w-[7rem] invert cursor-pointer' onClick={homePage} />
                    <div className='relative w-[50%] h-[70%] rounded-[10px] bg-[#FFFFFF] flex flex-row'>
                        {/* <div className='h-full w-[25%]  flex flex-row lg:gap-5 gap-2 justify-center items-center border-r-2 border-[#B2B2B2] cursor-pointer'>
                            <span className='font-[400] text-sm font-dmSans'>All Category</span>
                            <img src={arrow} alt="arrow" />
                        </div> */}
                        <div className='h-full w-[90%]  border-r-2 border-[#B2B2B2]'>
                            <input
                                type="text"
                                className='w-full h-full font-dmSans pl-5 outline-none rounded-l-[10px]'
                                placeholder='Search Products...'
                                value={searchQuery}
                                onChange={(e) => handleSearchQuery(e)}
                                onBlur={handleOnBlur}
                                onFocus={handleOnFocus}
                                onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                            />
                        </div>
                        <div className='h-full w-[10%]  flex justify-center items-center cursor-pointer' onClick={handleSearch}>
                            <img src={search} alt="search" />
                        </div>

                        {(searchLoading || searchProducts.length > 0) && (
                            <div className="absolute top-[120%] left-0 w-full max-h-[60vh] bg-white shadow-2xl rounded-2xl border border-gray-100 overflow-hidden z-[60] animate-in overflow-y-auto custom-scroll">
                                <div className="p-2 bg-gray-50 border-b border-gray-100 text-[10px] font-bold text-gray-400 tracking-widest uppercase">
                                    {searchLoading ? 'Searching...' : `Search Results (${searchProducts.length})`}
                                </div>

                                {searchLoading ? (
                                    // Shimmer loading skeleton
                                    Array.from({ length: searchProducts.length || 1 }).map((_, index) => (
                                        <div
                                            key={`skeleton-${index}`}
                                            className="w-full p-3 flex items-center gap-4 border-b border-gray-50 last:border-0 animate-pulse"
                                            style={{ opacity: 1 - index * 0.25 }}
                                        >
                                            <div className="w-12 h-12 rounded-lg bg-gray-200 flex-shrink-0"></div>
                                            <div className="flex flex-col gap-2 flex-grow">
                                                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                                                <div className="h-3 bg-gray-100 rounded w-1/2"></div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    searchProducts.map((pro, index) => (
                                        <div
                                            key={pro.Id}
                                            className="group w-full p-3 flex items-center gap-4 hover:bg-gray-50 transition-all duration-200 cursor-pointer border-b border-gray-50 last:border-0"
                                            onMouseDown={() => {
                                                fullimage(pro.Id, pro.ItemName);
                                            }}
                                        >
                                            <div className="w-12 h-12 rounded-lg bg-gray-100 overflow-hidden flex-shrink-0 border border-gray-200">
                                                <img
                                                    src={pro.displayFirst ? `${apiLocalUrl}/uploads/${pro.displayFirst}` : search}
                                                    alt={pro.ItemName}
                                                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = search;
                                                    }}
                                                />
                                            </div>
                                            <div className="flex flex-col overflow-hidden">
                                                <span className="text-sm font-semibold text-gray-800 truncate group-hover:text-black transition-colors uppercase font-montserrat tracking-tight">
                                                    {pro.ItemName}
                                                </span>
                                                <span className="text-[10px] text-left text-gray-400 font-medium">
                                                    {pro.ItemName}
                                                </span>
                                            </div>
                                            <div className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity">
                                                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                                </svg>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        )}
                    </div>

                    <div className='flex flex-row gap-4'>
                        <div className='flex flex-row gap-2 cursor-pointer' onClick={cartpage}>
                            <img src={cart} alt="cart" />
                            <span className='text-sm font-[400] font-dmSans text-[#CACACA] hover:text-[red] '>Cart</span>
                        </div>
                        <div className='flex flex-row border-r-2 border-[#B2B2B2]'>

                        </div>
                        <div className='flex flex-row gap-2 cursor-pointer' onClick={accountpage}>
                            <img src={profile} alt="profile" />
                            <span className='text-sm font-[400] font-dmSans text-[#CACACA] hover:text-[red]'>Account</span>
                        </div>
                    </div>
                </div>
            </div>



            <div className={`w-full h-[55px] bg-[#000000] flex justify-between items-center lg:px-12 px-5 fixed left-0 z-40 transition-all duration-300 ${isVisible ? 'top-[120px]' : 'top-[65px] opacity-0 pointer-events-none'}`}>
                <div className='flex flex-row lg:gap-12 gap-5'>
                    <div
                        className="relative flex flex-row gap-2 cursor-pointer"
                        onClick={(e) => {
                            e.stopPropagation()
                            setShowDropdown(!showDropdown)
                        }}
                        onBlur={() => setShowDropdown(false)}
                    >
                        {/* <img src={bars} alt="bars" /> */}
                        <span className="text-sm text-nowrap font-600 text-[white] hover:text-[red] uppercase">All Categories</span>

                        {/* Dropdown Menu */}
                        {showDropdown && (
                            <div className="absolute top-7 left-0 w-[220px] bg-[#eee] shadow-2xl border border-[#9b9b9b] rounded-xl p-2 z-50">
                                <ul className="text-black max-h-[350px] overflow-y-auto custom-scroll pr-1">
                                    {categories.length > 0 ? (
                                        categories.map(category => (
                                            <li
                                                key={category.Id}
                                                className="p-3 mb-1 rounded-lg bg-white border border-transparent hover:bg-black hover:text-white hover:border-black transition-all duration-200 cursor-pointer shadow-sm"
                                                onClick={() => productPage(category.Id, category.Name)}
                                            >
                                                {category.Name}
                                            </li>
                                        ))
                                    ) : (
                                        <li className="p-2 text-gray-500">Loading...</li>
                                    )}
                                </ul>
                            </div>
                        )}

                    </div>
                    <span className='font-[400] text-sm font-dmSans uppercase text-[white] cursor-pointer hover:text-[red]' onClick={mensubcategorypage}>Men</span>
                    <span className='font-[400] text-sm font-dmSans uppercase text-[white] cursor-pointer hover:text-[red]' onClick={womensubcategorypage}>Women</span>

                    <span className='font-[400] text-sm font-dmSans uppercase text-[white] cursor-pointer hover:text-[red]' onClick={kidssubcategorypage}>Kids</span>


                </div>
                {/* <span className='font-[400] text-sm font-dmSans text-[white] cursor-pointer hover:text-[red]' >Dashboard</span> */}
                {admin === '1' && (
                    <img src={dashboardpageimg} alt="dashboardpageimg" onClick={dashboardpage} className='cursor-pointer' />
                )}
                <div className='flex flex-row lg:gap-12 gap-5'>

                    <span className='font-[400] text-sm font-dmSans text-[white] uppercase cursor-pointer hover:text-[red] ' onClick={limitedsalesubcategorypage}>LIMITED SALE</span>
                    <span className='font-[400] text-sm font-dmSans text-[white] uppercase cursor-pointer hover:text-[red]' onClick={bestsellersubcategorypage}>Best Seller</span>
                    <span className='font-[400] text-sm font-dmSans text-[white] uppercase cursor-pointer hover:text-[red]' onClick={newarrival}>New Arrival</span>


                </div>
            </div>
        </div>
    )
}

export default Navbar
